export const buildChartjsPluginsProp = () => {
  return [{
    afterDatasetsDraw: function (chart) {
      const ctx = chart.ctx

      chart.data.datasets.forEach(function (dataset) {
        dataset.data.forEach(function (data, index) {
          const meta = chart.getDatasetMeta(0)
          const model = meta.data[index]

          const left = model.x
          const top = model.y
          const width = model.width
          const height = model.height

          ctx.save()
          ctx.fillStyle = '#ffffff'

          const dynamicFontSize = Math.min(width, height) * 0.3125
          ctx.font = `${dynamicFontSize}px Catamaran`
          ctx.textAlign = 'center'
          ctx.textBaseline = 'middle'
          const value = data.v + '%'

          const textX = left + width / 2
          const textY = top + height / 2

          ctx.fillText(value, textX, textY)
          ctx.restore()
        })
      })
    }
  }]
}
